import { RawLocation } from "vue-router";
import language from "@/api/language";

export default function (to: RawLocation) {

    if (to instanceof String || typeof to === "string") {
        if (language() === 'en') {
            if (to.startsWith('/')) {
                to = to.substring(1)
            }

            return `/en/${to}`
        }
    }

    if (to instanceof Object) {
        if (language() === 'en') {

            if (to.name) {
                to.name = `en-${to.name}`
                return to
            }


            if (to.path) {
                if (to.path.startsWith('/')) {
                    to.path = to.path.substring(1)
                }
                to.path = `/en/${to.path}`
                return to
            }

        }
    }


    return to;


}